// extracted by mini-css-extract-plugin
module.exports = {"noImageMemoryWrapper":"styles_noImageMemoryWrapper__Xmh7_","noCommentsWrapper":"styles_noCommentsWrapper__NATLF"};